export default "__VITE_ASSET__BlMeMuLw__"